const CART_SUCCESS_TOAST_LIMIT = 2;
const CART_SUCCESS_TOAST_DURATION = 3500;
const cartSuccessToasts = [];

function removeCartSuccessToast(toast, animate = true) {
  const toastIndex = cartSuccessToasts.findIndex((entry) => entry.element === toast);

  if (toastIndex !== -1) {
    window.clearTimeout(cartSuccessToasts[toastIndex].timeoutId);
    cartSuccessToasts.splice(toastIndex, 1);
  }

  if (!animate) {
    toast.remove();
    return;
  }

  toast.classList.add('cart-success-toast--leaving');

  window.setTimeout(() => {
    toast.remove();
  }, 220);
}

function getCartSuccessToastContainer() {
  let container = document.querySelector('.cart-success-toast-container');

  if (!container) {
    container = document.createElement('div');
    container.className = 'cart-success-toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-atomic', 'false');
    document.body.appendChild(container);
  }

  return container;
}

function showCartSuccessToast() {
  const container = getCartSuccessToastContainer();

  while (cartSuccessToasts.length >= CART_SUCCESS_TOAST_LIMIT) {
    removeCartSuccessToast(cartSuccessToasts[0].element, false);
  }

  const toast = document.createElement('div');
  toast.className = 'cart-success-toast';
  toast.setAttribute('role', 'status');
  toast.innerHTML = `
    <span class="cart-success-toast__icon" aria-hidden="true">
      <svg class="cart-success-toast__svg" width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M55.731 53.4C53.5259 53.707 51.7336 55.3168 51.2085 57.46C50.4657 60.4946 47.2797 62.2673 44.2779 61.3167C42.1567 60.6462 39.8374 61.3256 38.4253 63.0309C36.4267 65.4459 32.7804 65.673 30.4916 63.5266C28.8745 62.0106 26.4879 61.6244 24.4689 62.5547C21.6105 63.8707 18.2252 62.5088 17.1033 59.5906C16.311 57.5292 14.3288 56.1559 12.1022 56.1257C8.95113 56.083 6.49849 53.4007 6.76452 50.2887C6.95308 48.0914 5.76835 46.0017 3.77602 45.0178C0.955768 43.6244 -0.0797625 40.1527 1.52337 37.4641C2.65541 35.5649 2.50303 33.1733 1.13926 31.4295C-0.791491 28.9623 -0.204204 25.3893 2.41669 23.6556C4.2687 22.4314 5.17852 20.2115 4.71377 18.0544V18.0538C4.05411 15.001 6.14802 12.0343 9.26858 11.5997C11.4736 11.2927 13.2659 9.68354 13.7916 7.5397C14.5345 4.50575 17.7198 2.73243 20.7223 3.68231C22.8429 4.35352 25.1622 3.67476 26.5748 1.96875C28.5735 -0.445578 32.2198 -0.673298 34.5086 1.47368C36.1251 2.98972 38.5123 3.3747 40.5313 2.44495C43.389 1.12896 46.7737 2.49087 47.8962 5.40908C48.6886 7.47051 50.6714 8.84374 52.8974 8.87394C56.0484 8.91672 58.5017 11.5997 58.235 14.711C58.0465 16.9089 59.2306 18.998 61.2242 19.9825C64.0438 21.3759 65.0793 24.847 63.4768 27.5356C62.3441 29.4354 62.4965 31.8264 63.8603 33.5696C65.7917 36.038 65.2044 39.6104 62.5829 41.3435C60.7315 42.5683 59.8204 44.7888 60.2864 46.9459C60.9454 49.9987 58.8522 52.9654 55.731 53.4Z" fill="#E06600"/>
        <path d="M47.5591 18.04L25.5177 39.8791L17.4411 31.8781L13.8672 35.4197L25.5177 46.9629L29.0916 43.4207L51.1342 21.581L47.5591 18.04Z" fill="white"/>
      </svg>
    </span>
    <span class="cart-success-toast__text">Cart updated successfully</span>
  `;

  container.appendChild(toast);

  const timeoutId = window.setTimeout(() => {
    removeCartSuccessToast(toast);
  }, CART_SUCCESS_TOAST_DURATION);

  cartSuccessToasts.push({ element: toast, timeoutId });
}

document.addEventListener('cart:update', (event) => {
  const data = event.detail?.data;

  if (data?.source !== 'product-form-component' || data.didError) return;

  showCartSuccessToast();
});

const WAITLIST_DETAILS_SELECTOR = '.product-details';
const WAITLIST_FORM_SELECTOR = 'shopify-forms-embed';
const WAITLIST_PRODUCT_FORM_SELECTOR = 'product-form-component';
const WAITLIST_ACTIVE_CLASS = 'product-details--waitlist-active';

function updateWaitlistVisibility(productDetails, isSoldOut) {
  const waitlistForm = productDetails.querySelector(WAITLIST_FORM_SELECTOR);
  const productForm = productDetails.querySelector(WAITLIST_PRODUCT_FORM_SELECTOR);
  console.log(waitlistForm, "waitlistForm")
  console.log(productForm, "productForm")
  console.log(isSoldOut, "isSoldOut")
  if (!waitlistForm || !productForm) return;

  productDetails.classList.toggle(WAITLIST_ACTIVE_CLASS, isSoldOut);
  productForm.hidden = isSoldOut;
  productForm.setAttribute('aria-hidden', isSoldOut ? 'true' : 'false');
  waitlistForm.hidden = !isSoldOut;
  waitlistForm.style.display = isSoldOut ? 'block' : 'none';
  waitlistForm.setAttribute('aria-hidden', isSoldOut ? 'false' : 'true');
}

function isCurrentVariantSoldOut(productDetails) {
  const addToCartButton = productDetails.querySelector(`${WAITLIST_PRODUCT_FORM_SELECTOR} button[name="add"]`);

  return Boolean(addToCartButton?.disabled);
}

function initWaitlistVisibility(scope = document) {
  scope.querySelectorAll(WAITLIST_DETAILS_SELECTOR).forEach((productDetails) => {
    updateWaitlistVisibility(productDetails, isCurrentVariantSoldOut(productDetails));
  });
}

document.addEventListener('variant:update', (event) => {
  const productDetails = event.target instanceof Element ? event.target.closest(WAITLIST_DETAILS_SELECTOR) : null;

  if (!productDetails) return;

  updateWaitlistVisibility(productDetails, !event.detail?.resource?.available);
});

document.addEventListener('DOMContentLoaded', () => {
  initWaitlistVisibility();

  const waitlistObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches(WAITLIST_DETAILS_SELECTOR)) {
          initWaitlistVisibility(node.parentElement || document);
          return;
        }

        const productDetails = node.closest(WAITLIST_DETAILS_SELECTOR) || node.querySelector(WAITLIST_DETAILS_SELECTOR);

        if (productDetails) {
          initWaitlistVisibility(productDetails.parentElement || document);
        }
      });
    });
  });

  waitlistObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
});




document.addEventListener('DOMContentLoaded', () => {
  function openOmnisendForms() {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', '68d40f78845e5c93e3f14ab2']);
  }

  function initPreLaunchButtons() {
    let pre_launch_btn = document.querySelectorAll('.pre_launch_btn');
    if (pre_launch_btn.length > 0) {
      pre_launch_btn.forEach((btn) => {
        btn.addEventListener('click', openOmnisendForms);
      });
    }
  }

  // Call the function after DOM is loaded
  initPreLaunchButtons();
  document.addEventListener('related:happen', initPreLaunchButtons);

  //Launching soon Button
  function openLaunchingSoonForm() {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', '68d40f78845e5c93e3f14ab2']);
  }

  function initLaunchingSoon() {
    let pre_launch_btn = document.querySelectorAll('.launching_soon');
    if (pre_launch_btn.length > 0) {
      pre_launch_btn.forEach((btn) => {
        btn.addEventListener('click', openLaunchingSoonForm);
      });
    }
  }

  // Call the function after DOM is loaded
  initLaunchingSoon();
  document.addEventListener('related:happen', initLaunchingSoon);
});

$(document).ready(function() {
  $(".dynamic_title h3").each(function(i) {
   var heading = $(this);
    var headingtext = heading.text().toLowerCase().trim().replace(/[\s.,-\/#!?$%\^&\*;:{}=\-_`~()]/g,"-");
     heading.attr("id",headingtext);
    heading.each(function(){
      $(".dynamic_title #article-titles").append(`<li><a href="#${headingtext}">${$(this).text()}</a></li>`);
    })
   });
});

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector(".header");

//   if (!header) return;

//   function updateHeaderHeight() {
//     const headerRect = header.getBoundingClientRect();
//     const isHeaderVisible = headerRect.top >= 0 && headerRect.bottom > 0; // Detect visibility

//     if (isHeaderVisible) {
//       document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
//       console.log("Header is Visible:", header.offsetHeight);
//     } else {
//       document.documentElement.style.setProperty("--header-height", "10px");
//       console.log("Header is Not Visible");
//     }
//   }

//   window.addEventListener("scroll", updateHeaderHeight);
//   window.addEventListener("resize", updateHeaderHeight);

//   // Run once on page load
//   updateHeaderHeight();

// Browse By Department Start
let browseByDepDrop = document.querySelectorAll('.product_list_wrapper .swiper.product_list_init');
  browseByDepDrop.forEach(function(browseByDepSlider){
    let browseByDepartment = new Swiper(browseByDepSlider, {
      // Optional parameters
      loop: false,
      slidesPerView:3,
      spaceBetween: 15,
      followFinger: true,
      speed: 750,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 2,
      },
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 10,
        },
        576: {
          slidesPerView: 2.2,
          spaceBetween: 15,
        },
        1100: {
          slidesPerView: 3,
          spaceBetween: 18,
        }
      }
    }); 
  })
// });

